module.exports = __webpack_public_path__ + "img/mountains.5ebdafee.png";